import { render } from "./ResponseModal.vue?vue&type=template&id=8b4d2d54&scoped=true"
import script from "./ResponseModal.vue?vue&type=script&lang=js"
export * from "./ResponseModal.vue?vue&type=script&lang=js"

import "./ResponseModal.vue?vue&type=style&index=0&id=8b4d2d54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4d2d54"]])

export default __exports__